import React from 'react';

import styles from './ScreenReaderOnly.module.css';

const ScreenReaderOnly = ({ children }: { children: string | React.ReactNode }) => (
  <span className={styles.root}>{children}</span>
);

export default ScreenReaderOnly;
